import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSearchResults,
  setFilteredGames,
  setGameDetails,
  setGamePopup,
  setSearchInput,
} from "../crashGames/cl_CrashSlice";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useNavigate } from "react-router";
import { getFromLocalStorage, buildGameLaunchUrl } from "../../services/helper/cl_Helper";
import statickImg from "../../assets/images/popup/staticImg.webp";
import { setIsSideMenuOpened } from "../signUp/cl_SignUpSlice";
import {  setIsSearchBoxOpen, setSearchCtg } from "../signIn/cl_SignInSlice";
import useFilterGamesByType from "../../services/helper/filterGamesByType";

const SearchScreen = () => {
  const topRef = useRef(null);
  const inputRef = useRef(null); 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [combinedGames, setCombinedGames] = useState([]);
  const { getAllgamesList } = useSelector((state) => state?.crash);
  useEffect(() => {
    const combinedData = getAllgamesList.reduce((acc, category) => {
      return acc.concat(category?.game);
    }, []);

    setCombinedGames(combinedData);
    dispatch(setSearchInput(""));
  }, [getAllgamesList]);

  const popularGames =
    combinedGames?.filter(
      (game) =>
        game.categoryname?.toLowerCase() === "popular games" ||
        game.game_type?.toLowerCase() === "common"
    ) || [];

  const uniquePopularGames = [
    ...new Set(popularGames.map((game) => JSON.stringify(game))),
  ].map((game) => JSON.parse(game));

  const { staticContent } = useSelector((state) => state?.topGamesList);
  const { filteredGames, gamePopup } = useSelector((state) => state?.crash);
  const { IsSearchBoxOpen } = useSelector((state) => state?.signIn);
  const { searchInput } = useSelector((state) => state?.crash);

  const filterByGameType = useFilterGamesByType();

  const [gameCategories, setGameCategories] = useState([]);

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  useEffect(() => {
    if (Array.isArray(staticContent)) {
      const categories = staticContent
        .filter((item) => item.is_active && item.menu_name !== "Promotions" && item.menu_name !== "Loyalty")
        .map((item) => ({
          name: item.menu_name,
          icon: item.icontags,
        }));

      setGameCategories(categories);
    }
  }, [staticContent]);

  useEffect(() => {
    const header = document.querySelector(".SB-layout-header");
    if (header) {
      header.style.position = IsSearchBoxOpen ? "relative" : "sticky";
    }
  }, [IsSearchBoxOpen]);

  useEffect(() => {
    if (IsSearchBoxOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [IsSearchBoxOpen]);

  const handleSearchData = (event) => {
    event.preventDefault();
    const searchValue = event.target.value;
    dispatch(setSearchInput(searchValue));
    
    if (searchValue) {
      // Create flattened and deduplicated games list
      const flattenedGames = getAllgamesList.reduce((acc, category) => {
        return acc.concat(category?.game || []);
      }, []);
      
      // Remove duplicates based on game_code
      const uniqueGames = flattenedGames.filter((game, index, self) =>
        index === self.findIndex((g) => g.game_code === game.game_code)
      );
      
      dispatch(getSearchResults(uniqueGames, searchValue));
    } else {
      dispatch(setFilteredGames([]));
    }
  };

  const navigateToGamePopup = (game) => {
    const token = getFromLocalStorage("gk");
    if (token) {
      dispatch(setSearchCtg(false));
      dispatch(setIsSearchBoxOpen(false));
      dispatch(setSearchInput(""));
      const url = buildGameLaunchUrl(game, { gameClose: true });
      window.location.href = url;
    } else {
      navigate("/signin");
    }
  };

  const handleCategoryClick = (categoryName) => {
    const token = getFromLocalStorage("gk");
    if (!token) {
      navigate("/signin");
      return;
    }
    const filteredGames = filterByGameType(categoryName);
    const gamesList =
      filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];

    dispatch(setSearchCtg(true));
    dispatch(setIsSearchBoxOpen(false));
    dispatch(setSearchInput(""));
    // dispatch(setHomePopUp(true));
    navigate(`/games/${categoryName}`, {
      state: {
        gamesList,
        title: categoryName,
      },
    });
  };

  return (
    <>
      <div className="SB-search-container" ref={topRef}>
        {IsSearchBoxOpen ? (
          <>
            <div className="SB-iconSVG SB-iconSearch">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#${"icon-search"}`} />
              </svg>
            </div>
            <div className="SB-search">
              <div className="SB-searchBox-container">
                <div className="SB-searchBox">
                  <input
                    ref={inputRef} 
                    type="text"
                    id="SB-inputField"
                    placeholder="Search"
                    onChange={handleSearchData}
                    value={searchInput}
                    autoComplete="off"
                  />
                  <div className="SB-searchButton">
                    <div className="SB-iconSVG">
                      {searchInput?.length > 0 ? (
                        <div
                          className="SB-searchClear"
                          onClick={() => {
                            dispatch(setSearchInput(""));
                          }}
                        >
                          <div className="SB-iconSVG">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-back-delete"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <use xlinkHref={`${icons}#${"icon-search"}`} />
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="SB-searchClose"
                  onClick={() => {
                    navigate("/");
                    dispatch(setSearchCtg(false));
                    dispatch(setIsSearchBoxOpen(false));
                    dispatch(setSearchInput(""));
                  }}
                >
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-close"}`} />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="SB-searchResult-content">
                {searchInput !== "" ? (
                  filteredGames?.length > 0 ? (
                    <>
                      <div className="SB-casinoSearchResult-section SB-searchResult-section">
                        <div className="SB-casinoSearchResult-section-title">
                          Search Results ({filteredGames?.length})
                        </div>
                        <div className="SB-casinoSearchResult-section-content">
                          <ul className="SB-casinoSearchResultGamesList">
                            {filteredGames?.map((game, index) => (
                              <li key={index}>
                                <div
                                  className="SB-casinoSearchResult-item"
                                  onClick={() => navigateToGamePopup(game)}
                                >
                                  <img
                                    src={
                                      (game?.image?.configurl ||
                                        game?.image?.url) === "NoIcon"
                                        ? statickImg
                                        : game?.image?.configurl ||
                                          game?.image?.url ||
                                          statickImg
                                    }
                                    data-splide-lazy={
                                      (game?.image?.configurl ||
                                        game?.image?.url) === "NoIcon"
                                        ? statickImg
                                        : game?.image?.configurl ||
                                          game?.image?.url ||
                                          statickImg
                                    }
                                    alt=""
                                    loading="lazy"
                                    onError={(e) => {
                                      e.target.src = statickImg;
                                    }}
                                  />
                                  <div className="SB-casinoSearchResult-item-title">
                                    {game?.name
                                      ? game.name.charAt(0).toUpperCase() +
                                        game.name.slice(1).toLowerCase()
                                      : ""}
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="SB-msgBox">
                      <div className="SB-msgBox-container">
                        No results found
                      </div>
                    </div>
                  )
                ) : null}

                <div className="SB-casinoSearchResult-section SB-suggestedGames-section">
                  <div className="SB-casinoSearchResult-section-title">
                    Suggested Games
                  </div>
                  <div className="SB-casinoSearchResult-section-content">
                    <ul className="SB-casinoSearchResultGamesList">
                      {uniquePopularGames?.map((game, index) => (
                        <li key={index}>
                          <div
                            className="SB-casinoSearchResult-item"
                            onClick={() => navigateToGamePopup(game)}
                          >
                            <img
                              src={
                                (game?.image?.configurl || game?.image?.url) ===
                                "NoIcon"
                                  ? statickImg
                                  : game?.image?.configurl ||
                                    game?.image?.url ||
                                    statickImg
                              }
                              style={{
                                backgroundImage: `url(${game?.bgImg})`,
                              }}
                              onError={(e) => {
                                e.target.src = statickImg;
                              }}
                            />
                            <div className="SB-casinoSearchResult-item-title">
                              {game?.name
                                ? game.name.charAt(0).toUpperCase() +
                                  game.name.slice(1).toLowerCase()
                                : ""}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="SB-casinoSearchResult-section">
                  <div className="SB-casinoSearchResult-section-title">
                    Categories
                  </div>
                  <div className="SB-casinoSearchResult-section-content">
                    <ul className="SB-casinoSearchLinksList">
                      {gameCategories.map((category, index) => {
                        const filteredGames = filterByGameType(category.name);
                        if (!filteredGames[0]?.game?.length) return null;

                        return (
                          <li key={index}>
                            <div
                              className="SB-casinoLink-item"
                              onClick={() => handleCategoryClick(category.name)}
                            >
                              {category.name}
                              <div className="SB-iconSVG">
                                <svg xmlns="http://www.w3.org/2000/svg">
                                  <use
                                    xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                                  />
                                </svg>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div
            className="SB-iconSVG"
            onClick={() => {
              navigate("/");
              dispatch(setIsSideMenuOpened(false));
              dispatch(setIsSearchBoxOpen(true));
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg">
              <use xlinkHref={`${icons}#${"icon-search"}`} />
            </svg>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchScreen;
